import { EvidenceServiceApiKey } from "@app/injectionKeys";
import { injectStrict } from "@app/utils/injectStrict";
import { computed, ref } from "vue";

const apiKey = ref();
const aiModels = ref({
  dataExtractionModel: "gpt-4.1-mini",
  synthesisModel: "gpt-4.1-mini",
  screeningModel: "gpt-4.1-mini",
  medicalBackgroundPresetModel: "gpt-4.1",
  notifiedBodyPresetModel: "gpt-4.1",
});
const dataExtractionPrompt = ref<string>("");

export default () => {
  const evidenceService = injectStrict(EvidenceServiceApiKey);

  async function init() {
    const { data } = await evidenceService.api.settingsControllerGetOpenAiKey();
    apiKey.value = data;
  }

  async function initModels() {
    const { data } = await evidenceService.api.settingsControllerGetAiModels();
    aiModels.value = data;
  }

  async function initDataExtractionPrompt() {
    const { data } = await evidenceService.api.settingsControllerGetDataExtractionPrompt();
    dataExtractionPrompt.value = data;
  }

  async function configure(apiKey: string) {
    await evidenceService.api.settingsControllerSetOpenAiKey({
      key: apiKey,
    });
    await init();
  }

  async function updateModels(models: {
    dataExtractionModel?: string;
    synthesisModel?: string;
    screeningModel?: string;
    medicalBackgroundPresetModel?: string;
    notifiedBodyPresetModel?: string;
  }) {
    await evidenceService.api.settingsControllerSetAiModels(models);
    await initModels();
  }

  async function updateDataExtractionPrompt(prompt: string) {
    await evidenceService.api.settingsControllerSetDataExtractionPrompt({
      prompt,
    });
    await initDataExtractionPrompt();
  }

  async function resetDataExtractionPrompt() {
    const { data } = await evidenceService.api.settingsControllerGetDefaultDataExtractionPrompt();
    return data;
  }

  const isConfigured = computed(() => !!apiKey.value);

  async function validateOpenAiKey(apiKey: string) {
    await evidenceService.api.settingsControllerValidateOpenAiKey({
      key: apiKey,
    });
  }

  return {
    apiKey,
    aiModels,
    dataExtractionPrompt,
    configure,
    updateModels,
    updateDataExtractionPrompt,
    resetDataExtractionPrompt,
    init,
    initModels,
    initDataExtractionPrompt,
    isConfigured,
    validateOpenAiKey,
  };
};
